import { CommonModule } from '@angular/common';
import { HttpClientJsonpModule, HttpClientModule } from '@angular/common/http';
import { NgModule } from '@angular/core';

import { GoogleBooksService } from './google-books.service';

@NgModule({
  imports: [CommonModule, HttpClientModule, HttpClientJsonpModule],
  providers: [GoogleBooksService],
})
export class GoogleBooksModule {}
